module.exports = __webpack_public_path__ + "img/egg_melons_sad.bee4cbe2.svg";